<template>
  <div class="display-container flex flex-col section_8">
    <div class="flex flex-row justify-between items-center" style="margin-bottom: 7px">
      <div class="flex flex-row items-baseline space-x-9">
        <span v-if="!data.titleHidden" class="font_4">{{ data.title }}</span>
      </div>
      <div v-if="data.showMoreButton" class="flex flex-row items-center justify-between">
        <span class="font_5 text_14">更多</span>
        <img class="shrink-0 image_7" src="https://ysh-cdn.kaidicloud.com/test/home-page/2024/04/25/5b228aff321d47c18ec1ef371875389c.png" alt="" style="margin-left: 4px" />
      </div>
    </div>

    <div class="activity-list flex justify-between">
      <div class="acitivity-item">
        <div class="activity-cover">
          <img src="https://ysh-cdn.kaidicloud.com/codefun/preview/d611c275297947f6b0ca073f79ef776e.png" alt="" class="display" />

          <img src="https://ysh-cdn.kaidicloud.com/codefun/preview/d611c275297947f6b0ca073f79ef776e.png" alt="" class="bg" />
        </div>

        <img src="https://ysh-cdn.kaidicloud.com/test/home-page/2024/04/25/a19b79f05fa7461f90ac60c4f44483bd.gif" alt="" class="activity-corner" />
        <div class="activity-title line-clamp-2">点燃梦想相信香信的力量创造创造</div>
      </div>

      <div class="acitivity-item">
        <div class="activity-cover">
          <img src="https://ysh-cdn.kaidicloud.com/codefun/preview/ab3a59d8e152d89acb81568cf2997a57.png" alt="" class="display" />

          <img src="https://ysh-cdn.kaidicloud.com/codefun/preview/ab3a59d8e152d89acb81568cf2997a57.png" alt="" class="bg" />
        </div>

        <img src="https://ysh-cdn.kaidicloud.com/test/home-page/2024/04/25/235bb637fb29485bbad906f1b4a6dc3a.png" alt="" class="activity-corner" />
        <div class="activity-title">铭记历史现代人的和平</div>
      </div>

      <div class="acitivity-item">
        <div class="activity-cover">
          <img src="https://ysh-cdn.kaidicloud.com/codefun/preview/d611c275297947f6b0ca073f79ef776e.png" alt="" class="display" />

          <img src="https://ysh-cdn.kaidicloud.com/codefun/preview/d611c275297947f6b0ca073f79ef776e.png" alt="" class="bg" />
        </div>
        <div class="tag-wrap flex items-center">
          <img src="https://ysh-cdn.kaidicloud.com/test/home-page/2024/04/25/56e44556d37c4bd68b6d300e39b5e523.png" alt="" class="hot" />
          <div class="num">2.86万</div>
        </div>

        <div class="activity-title">走进吉林-企业家制造业项目</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {}
  },
  computed: {
    data() {
      return this.content[0]
    },
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.display-container {
  width: 686px;
  margin: 0 auto;
  background: url(https://ysh-cdn.kaidicloud.com/front_static/2024/04/26/66ffb5b775904af4852071077ea9902a.png);
  background-size: cover;
}

.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.section_8 {
  padding: 24px;
  background-color: #ffffff;
  border-radius: 16px;
  .space-x-9 {
    & > *:not(:first-child) {
      margin-left: 18px;
    }
    .font_4 {
      font-size: 34px;
      line-height: 48px;
      font-weight: 500;
      color: #222222;
    }
  }
  .font_5 {
    font-size: 24px;
    line-height: 34px;
    color: #999999;
  }
  .text_14 {
    font-size: 26px;
    line-height: 36px;
  }
  .image_7 {
    width: 8px;
    height: 14px;
  }
}

.activity-list {
  .acitivity-item {
    position: relative;
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }

  .activity-cover {
    position: relative;
    width: 202px;
    height: 280px;
    border-radius: 16px;
    margin-bottom: 10px;
    overflow: hidden;

    .bg {
      width: 100%;
      height: 100%;
      filter: blur(16px);
    }

    .display {
      position: absolute;
      z-index: 1;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .activity-corner {
    position: absolute;
    top: 0;
    right: 0;
    width: 104px;
    height: 36px;
  }

  .tag-wrap {
    position: absolute;
    top: 0;
    right: 0;
    height: 36px;
    border-radius: 0 16px 0 0;
    overflow: hidden;

    .hot {
      width: 64px;
      height: 36px;
    }

    .num {
      font-size: 20px;
      color: #ffffff;
      line-height: 28px;
      background: rgba(0, 0, 0, 0.5);
      padding: 4px 8px;
    }
  }

  .activity-title {
    width: 202px;
    font-size: 28px;
    color: #222222;
    line-height: 40px;
  }
}
</style>
